<template>
  <div id="app">
      <router-view></router-view>
      <loading :active.sync="$store.state.isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import api from './services/service'

export default {
  name: 'app',
  components: {
    Loading
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$store.state.screenWidth = window.innerWidth
      this.$store.state.screenHeight = window.innerHeight
    },
    getConfig () {
      this.$store.state.isLoading = true
      api.getConfig(
        result => {
          if (result.response === true) {
            this.$store.state.config = result.data
            sessionStorage.config = JSON.stringify(result.data)
          } else {
            this.getConfig()
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getConfig()
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue